/* eslint-disable jsx-a11y/anchor-has-content */
import { RegistrationCommonInputProps } from 'features/registration/interface/registration';
import { FC } from 'react';
import { Trans } from 'react-i18next';
import Checkbox from 'shared/components/form/checkbox';
import { FormRow } from 'shared/components/form/formRow';

import './styles.scss';

const RegistrationStep9: FC<RegistrationCommonInputProps> = ({
	t,
	values,
	isFieldValueValid,
	touched,
	errors,
	setFieldValue,
	setValues = () => {},
}) => {
	return (
		<div className="RegistrationStep9__checkBoxList">
			<FormRow>
				<Checkbox
					name="selectAllConsents"
					label={t('selectEverything')}
					values={values}
					isFieldValueValid={isFieldValueValid}
					touched={touched}
					errors={errors}
					setFieldValue={setFieldValue}
					onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						const selectAllConsents = e.target.checked;
						setValues({
							...values,
							selectAllConsents,
							emailConsent: selectAllConsents,
							smsConsent: selectAllConsents,
							allConsents: selectAllConsents,
							ageConsent: selectAllConsents,
						});
					}}
					cyTestRef="all-consents"
				/>
			</FormRow>
			<FormRow>
				<Checkbox
					name="ageConsent"
					label={t('ageConsentTitle')}
					values={values}
					isFieldValueValid={isFieldValueValid}
					touched={touched}
					errors={errors}
					setFieldValue={setFieldValue}
					description={
						<Trans
							t={t}
							i18nKey="ageConsentDescription"
							components={{
								br: <br />,
								a: <a href="/regulamin" target="_blank" />,
							}}
						/>
					}
					onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						const ageConsent = e.target.checked;
						setValues({
							...values,
							ageConsent,
							selectAllConsents: values.emailConsent && values.smsConsent && values.allConsents && ageConsent,
						});
					}}
					cyTestRef="age-consent"
				/>
			</FormRow>
			<FormRow flex={false}>
				<Checkbox
					name="allConsents"
					label={t('allConsents')}
					values={values}
					isFieldValueValid={isFieldValueValid}
					touched={touched}
					errors={errors}
					setFieldValue={setFieldValue}
					onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
						const allConsents = e.target.checked;
						setValues({
							...values,
							emailConsent: allConsents,
							smsConsent: allConsents,
							allConsents: allConsents,
							selectAllConsents: allConsents && values.ageConsent,
						});
					}}
					description={
						<Trans
							t={t}
							i18nKey="allConsentsDescription"
							components={{
								br: <br />,
								a: (
									<a
										href="https://storage.betfan.pl/undefined/regulations/dde507e0-22b3-46ac-8ffb-dffbea796407_Politykaprywatnosci.pdf"
										target="_blank"
										rel="noopener noreferrer"
									/>
								),
								a2: (
									<a
										href="https://storage.betfan.pl/undefined/regulations/ce1fb7c2-de82-4255-9de8-e64d3a75591a_KlauzulaInformacyjna.pdf"
										target="_blank"
										rel="noopener noreferrer"
									/>
								),
							}}
						/>
					}
					cyTestRef="all-consents"
				/>
			</FormRow>
			<FormRow isSubRow>
				<Checkbox
					name="emailConsent"
					label={t('newEmail')}
					values={values}
					isFieldValueValid={isFieldValueValid}
					touched={touched}
					errors={errors}
					setFieldValue={setFieldValue}
					onChange={(e: any) => {
						const emailConsent = e.target.checked;
						setValues({
							...values,
							emailConsent,
							allConsents: emailConsent && values.smsConsent,
							selectAllConsents: emailConsent && values.smsConsent && values.ageConsent,
						});
					}}
					cyTestRef="email-consent"
				/>
				<Checkbox
					name="smsConsent"
					label={t('phoneNum')}
					values={values}
					isFieldValueValid={isFieldValueValid}
					touched={touched}
					errors={errors}
					setFieldValue={setFieldValue}
					onChange={(e: any) => {
						const smsConsent = e.target.checked;
						setValues({
							...values,
							smsConsent,
							allConsents: smsConsent && values.emailConsent,
							selectAllConsents: smsConsent && values.emailConsent && values.ageConsent,
						});
					}}
					cyTestRef="sns-consent"
				/>
			</FormRow>
		</div>
	);
};

export default RegistrationStep9;
